import styles from './ModalFooter.css';

export const RegionalDistrictsModalFooter: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['modal-footer']}>{children}</div>;
};
